export default "__VITE_ASSET__56XnLZcy__"